import styled from 'styled-components';
// -----COMMON STYLED COMPONENTS IN CALENDAR PANEL---------------------------------

// Display Messages
export const StyledMessage = styled.div`
  width: 100%;
  height: 100%;
  color: #333;
  text-align: center;
  
  div {
    position: fixed;
    top: 50%;
    left: 50%;
    -ms-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
  }
  
  span {
    display: block;
    padding: 10px 0;
  }
`;

// -----COMMON STYLED COMPONENTS IN EDIT PANEL-------------------------------------

//Edit Panel Message Label 
export const StyledEditMessage = styled.div`
  font-size: 16px;
  width: 80%;
  margin: 0 auto;
  color: #444;
  font-size: 14px;
  line-height: 22px;
  font-family: inherit;
  background: #fff;
  color: #666;
  font-style: italic;
`
//Edit Panel Overlapping Warning Label
export const StyledOverlappingMessage = styled.div`
  width: 90%;
  margin: 20px auto 0 auto;
  font-size: 14px;
  line-height: 22px;
  color: #555;
  font-style: italic;
`
//Edit panel general label
export const StyledLabel = styled.div`    
  font-size: 16px;
  border: 0;  
  padding: 5px;
  margin: 0 0 10px 0;
  width: 100%;
  display: block;    
  text-align: center;
  color: #555;
  margin-top: 0;      
`;

// -------POWER MANAGEMENT TAB----------------------------------------------------------

//Toggle Label
export const StyledToggleLabel = styled.div`
  padding: 4px 10px;
  font-size: 16px;
  color: #333;
`;

// -------CAPABILITIES TAB--------------------------------------------------------------

//Topic label
export const TopicLabel = styled.div`
  width: 70%;
  color: #233567;
  text-align: left;
  margin: 0 0 15px auto;
`;

//Heading label (Left Column)
export const HeadingLabel = styled.div`
  color: #1F387A;
  text-align: right;
  margin: 0 0 10px 0;
`;

//General Label (Right Column)
export const GeneralLabel = styled.div<{margin?: string}>`
  color: #555555;
  text-align: left;
  margin: ${props => props.margin? props.margin : '0 0 10px 20px'};
`;

// Current Firmware Version, dynamic text colour
export const CurrentFirmwareLabel = styled.div<{ margin?: string; color?: string }>`
  color: ${props => props.color || '#555555'}; // Default color
  text-align: left;
  margin: ${props => (props.margin ? props.margin : '0 0 10px 20px')};
`;

// Span to separate version numbers for separate colouration
export const FirmwareSpan = styled.span<{ color?: string }>`
  color: ${props => props.color || '#555555'};
  text-align: left;
`